import { render, staticRenderFns } from "./SignatureMaker.vue?vue&type=template&id=0b6ddc1a&scoped=true"
import script from "./SignatureMaker.vue?vue&type=script&lang=js"
export * from "./SignatureMaker.vue?vue&type=script&lang=js"
import style0 from "./SignatureMaker.vue?vue&type=style&index=0&id=0b6ddc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6ddc1a",
  null
  
)

export default component.exports